import SortingSidebar from './SortingSidebar';

export default SortingSidebar;
